import { AsyncState } from 'widgets-for-react'
import { DishTeaserData } from '../dishTeasers/dishTeasersState'
import { loadDishHighlight } from './dishHighlightApi'

export type DishHighlightState = AsyncState<DishTeaserData | undefined>

export const initialDishHighlightState = (id: number): DishHighlightState =>
  loadDishHighlight(id)
